import React from "react"
import classnames from "classnames"
import styles from "./Typography.less"

class H4 extends React.PureComponent {
  render() {
    const { children, withDetails, white } = this.props
    return (
      <h4
        className={classnames({
          [styles.SameHeadingStyle]: true,
          [styles.H4]: true,
          [styles.WithDetails]: withDetails,
          [styles.white]: white
        })}>
        {children}
      </h4>
    )
  }
}


export default H4



// WEBPACK FOOTER //
// ./src/AtomicComponents/Typography/H4.jsx